// Shared slot-time helpers

export function timeToMin(t) {
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m;
}

/**
 * Returns true iff the given slot times (any order) are contiguous 30-min blocks
 * with no gaps. Used by the player booking flow to enforce continuous selection.
 */
export function isContiguous(times) {
    if (!times || times.length <= 1) return true;
    const sorted = [...times].sort();
    for (let i = 1; i < sorted.length; i++) {
        if (timeToMin(sorted[i]) - timeToMin(sorted[i - 1]) !== 30) return false;
    }
    return true;
}
